module.exports = __webpack_public_path__ + "static/media/SamusAran.e0113c7e.jpg";